import type { ReactElement } from 'react';
import type { ColumnDraft } from '../types';

type DestinationChipsProps = {
  value: ColumnDraft['destination'];
  onChange: (value: ColumnDraft['destination']) => void;
};

export function DestinationChips({ value, onChange }: DestinationChipsProps): ReactElement {
  const items: { v: ColumnDraft['destination']; label: string; activeCls: string }[] = [
    { v: 'customer', label: '顧客', activeCls: 'bg-primary text-inverted border-primary' },
    { v: 'contract', label: '契約', activeCls: 'bg-notice text-inverted border-notice' },
    { v: 'ignore', label: '無視', activeCls: 'bg-subtle text-default border-default' },
  ];
  return (
    <div className="inline-flex items-center gap-1">
      {items.map((item) => {
        const active = item.v === value;
        return (
          <button
            key={item.v}
            type="button"
            onClick={() => onChange(item.v)}
            className={`inline-flex h-6 min-w-[40px] items-center justify-center rounded-full border px-2.5 text-xs transition-colors ${
              active ? item.activeCls : 'border-muted bg-default text-muted-light hover:bg-subtle-light'
            }`}
            aria-pressed={active}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
